// Environments
export const DEV = process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'
export const STAGING = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
export const PRO = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'

export const LANGUAGES = ['en', 'es'] as const
export const LANG = process.env.NEXT_PUBLIC_LOCALE as typeof LANGUAGES[number]
export const LOCALE = LANG === 'en' ? 'en-GB' : `${LANG}-${LANG.toUpperCase()}`
export const DY_CMS = process.env.DY_CMS
export const DY_QUOTES_ENABLED = process.env.NEXT_PUBLIC_DY_QUOTES_ENABLED === 'true'
export const DY_INVOICES_ENABLED = process.env.NEXT_PUBLIC_DY_INVOICES_ENABLED === 'true'
export const DY_DISPLAY_CART_FOR_GUEST = process.env.NEXT_PUBLIC_DY_DISPLAY_CART_FOR_GUEST === 'true'

export const HOSTNAME = process.env.NEXT_PUBLIC_PROJECT_HOSTNAME
export const HOSTNAME_PUBLIC_WEB = process.env.NEXT_PUBLIC_PROJECT_HOSTNAME_PUBLIC
export const CLIENT_NAME = process.env.NEXT_PUBLIC_CLIENT_NAME
export const DY_B2B_WEB = process.env.DY_B2B_WEB === 'true'
export const DY_COOKIE_SESSION = 'DY_USER_AYB'
export const DY_COOKIE_SESSION_GUEST = 'DY_USER_AYB_GUEST_CART_TOKEN'
export const DY_COOKIE_DOMAIN = DEV ? 'localhost' : HOSTNAME

export const CONTACT_FORM_EXTERNAL_URL = 'https://forms.office.com/pages/responsepage.aspx?id=nVeCyFEj4kygUMJOPmUEthsbPDM9RkRHudIuqymudwNUQjZOVU00UU9RSE8xUkFBT0pKM1RHU0ZQMS4u&origin=lprLink&route=shorturl'

export * from './base'
export * from './project'
